import * as React from 'react';
import Rating, { RatingProps } from '@material-ui/lab/Rating';

export type DSRatingProps = RatingProps;

export const DSRating: React.FC<DSRatingProps> = props => <Rating {...props} />;
DSRating.displayName = 'DSRating';
